import Client from "../client";
import ConfigurationRepository from "./configurationRepository";
import PerformanceConfigurationResource from "../resources/performanceConfigurationResource";

class PerformanceConfigurationRepository extends ConfigurationRepository<PerformanceConfigurationResource> {
    constructor(client: Client) {
        super("PerformanceConfiguration", client);
    }
}

export default PerformanceConfigurationRepository;